(function(){
  var el=document.getElementById('tsf-rp'),src=document.getElementById('tsf-rp-data');
  if(!el||!src)return;
  try{if(sessionStorage.getItem('tsfRpClosed')==='1')return;}catch(e){}
  var raw;try{raw=JSON.parse(src.textContent||'[]');}catch(e){return;}
  var o24=0,gen=0;
  if(raw&&!Array.isArray(raw)){o24=parseInt(raw.orders_24h,10)||0;gen=Date.parse(raw.generated_at)||0;raw=raw.buyers||[];}
  if(!Array.isArray(raw))return;
  var WEEK=7*864e5,DAY=864e5,now=Date.now();
  // datos sin actualizar hace mas de 24 h (o sin fecha): no se muestra nada
  if(!gen||now-gen>DAY||gen>now+6e4)return;
  function cleanName(n){n=(n||'').trim().split(/\s+/)[0]||'';if(n.indexOf('@')>-1||n.replace(/\./g,'').length<2)return'';
    return n.charAt(0).toUpperCase()+n.slice(1).toLowerCase();}
  // una tarjeta por comprador (key = nombre+ciudad+estado), hora mas reciente, ultimos 7 dias
  var byKey={},list=[];
  raw.forEach(function(b){var t=Date.parse(b.at);if(!t||now-t>WEEK||t>now+6e4)return;
    var fn=cleanName(b.first_name),city=(b.city||'').trim(),st=(b.state||'').trim();
    if(!fn&&!st)return;
    var k=(b.key||(fn+'|'+city+'|'+st)).toLowerCase();
    var cur=byKey[k];
    if(!cur){cur=byKey[k]={fn:fn,city:city,st:st,items:[],img:b.img,t:t};list.push(cur);}
    (b.items||[]).forEach(function(i){if(cur.items.indexOf(i)<0)cur.items.push(i);});
    if(t>cur.t){cur.t=t;if(b.img)cur.img=b.img;}});
  list.sort(function(a,b){return b.t-a.t;});list=list.slice(0,5);
  if(list.length<2)list=[];
  // orden: comprador 1, 2, 3, conteo 24 h, comprador 4, 5
  var cards=list.slice(0,3);
  if(o24>=3&&gen&&now-gen<DAY)cards.push({count:o24,t:gen});
  cards=cards.concat(list.slice(3,5));
  if(!cards.length)return;
  function key(c){return c.count?'count':(c.fn+'|'+c.city+'|'+c.st+'|'+c.t);}
  var who=el.querySelector('.tsf-rp__who'),what=el.querySelector('.tsf-rp__what'),when=el.querySelector('.tsf-rp__when'),img=el.querySelector('.tsf-rp__img');
  function ago(t){var m=Math.max(1,Math.round((Date.now()-t)/6e4));
    if(m<60)return m+(m===1?' min ago':' mins ago');var h=Math.round(m/60);
    if(h<24)return h+(h===1?' hour ago':' hours ago');var d=Math.round(h/24);return d+(d===1?' day ago':' days ago');}
  function fit(items){var a=items[0]||'',n=items.length-1,opts=[];
    if(n===0)opts=['Purchased '+a,a];else{opts.push('Purchased '+items.join(' + '));
      if(n===1)opts.push('Purchased '+a+' + '+items[1]);opts.push('Purchased '+a+' + '+n+' more',a+' + '+n+' more',a);}
    for(var i=0;i<opts.length;i++){what.textContent=opts[i];if(what.scrollWidth<=what.clientWidth)return;}
    what.style.textOverflow='ellipsis';}
  var cur=null;if(window.ResizeObserver){var lastW=0;new ResizeObserver(function(){var w=what.clientWidth;if(cur&&cur.items&&w!==lastW){lastW=w;fit(cur.items);}}).observe(what);}
  var SHOW=5500,GAP=4500,FIRST=5000,SK='tsfRpState',timer,stopped=false;
  // estado de la visita: proxima posicion, momento de la proxima tarjeta, vistas en esta vuelta y ultima mostrada
  var st={pos:0,next:0,seen:[],last:null};
  try{var s=JSON.parse(sessionStorage.getItem(SK)||'null');if(s&&typeof s.pos==='number')st=s;}catch(e){}
  function save(){try{sessionStorage.setItem(SK,JSON.stringify(st));}catch(e){}}
  function pick(){var n=cards.length,j,c;
    for(j=0;j<n;j++){c=cards[(st.pos+j)%n];if(st.seen.indexOf(key(c))<0&&(key(c)!==st.last||n===1)){st.pos=(st.pos+j+1)%n;return c;}}
    st.seen=[];// termino la vuelta: empieza de nuevo sin repetir la ultima
    for(j=0;j<n;j++){c=cards[j];if(key(c)!==st.last||n===1){st.pos=(j+1)%n;return c;}}
    return cards[0];}
  function show(){if(stopped)return;var b=pick();cur=b;what.style.textOverflow='';
    st.seen.push(key(b));st.last=key(b);st.next=Date.now()+SHOW+GAP;save();
    if(b.count){el.classList.add('tsf-rp--count');who.textContent=b.count+' orders placed in the last 24 hours';what.textContent='';img.hidden=true;
      when.textContent='Updated '+ago(b.t);el.hidden=false;}
    else{el.classList.remove('tsf-rp--count');
      who.textContent=b.fn?(b.fn+' in '+(b.city?b.city+', ':'')+b.st):('Someone in '+(b.city?b.city+', ':'')+b.st);
      if(b.img){img.src=b.img+(b.img.indexOf('?')<0?'?':'&')+'width=120';img.hidden=false;}else img.hidden=true;
      when.textContent='\u2713 Order confirmed \u00b7 '+ago(b.t);
      el.hidden=false;fit(b.items);
      if(document.fonts&&document.fonts.ready)document.fonts.ready.then(function(){fit(b.items);});}
    requestAnimationFrame(function(){el.classList.add('is-in');});
    timer=setTimeout(function(){el.classList.remove('is-in');timer=setTimeout(show,GAP);},SHOW);}
  el.querySelector('.tsf-rp__close').addEventListener('click',function(){stopped=true;clearTimeout(timer);el.classList.remove('is-in');
    setTimeout(function(){el.hidden=true;},500);try{sessionStorage.setItem('tsfRpClosed','1');}catch(e){}});
  // primera vez en la visita: 5 s; si ya venia de otra pagina: lo que falte para la proxima (minimo 0,3 s)
  var wait=st.next?Math.max(300,st.next-Date.now()):FIRST;
  if(!st.next){st.next=Date.now()+FIRST;save();}
  timer=setTimeout(show,wait);
})();
